




































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import widgetCommon from './widgetCommon';
import { Toast } from 'vant';
@Component({
	name: 'stepsArticle',
})
export default class extends Mixins(widgetCommon) {
	private currentPoint: number = 0;
	private allWidth: number = 0;
	private oldValue: number = 0;
	private get rules() {
		return this.commonRule;
	}
	// 样式
	private get alignItems() {
		return this.item.showType === 1 ? 'center' : 'baseline';
	}
	private get lineStyle() {
		return {
			width: this.maxPointWidth + 'px',
			marginLeft: -this.maxPointWidth + 'px',
		};
	}
	private get visibility() {
		return this.showPercent ? 'visible' : 'hidden';
	}
	private get height() {
		return this.maxfontSize > 7 ? '86px' : '70px';
	}
	private get steps() {
		return this.item.options.filter((item) => !item.isDelete);
	}
	private get maxfontSize() {
		let max = this.steps[0].value.length;
		this.steps.forEach((step) => {
			if (step.value.length > max) {
				max = step.value.length;
			}
		});
		return max;
	}
	// 点状无百分比时最大宽度
	private get maxPointWidth() {
		const { allWidth, steps } = this;
		const maxWidth = allWidth / (steps.length - 1) - 6;
		return Math.max(120, maxWidth);
	}
	private get showPercent() {
		const { item } = this;
		return item.showType === 2 && item.showPercent;
	}
	public mounted() {
		let current = this.form[this.item.businessId];
		this.oldValue = current;
		this.currentPoint = this.steps.findIndex(({ key }) => key === current);
		if (this.type === 'record') {
			this.initField();
		}
		this.$nextTick(() => {
			this.allWidth = (this.$refs.ul as any).clientWidth;
		});
	}
	// 切换编辑状态时需要重新设置oldValue 用于检查节点是否可回退
	@Watch('isReadOnly')
	private changeReadState() {
		this.oldValue = this.form[this.item.businessId];
	}
	private initField() {
		if (this.isUndef(this.form[this.item.businessId])) {
			this.form[this.item.businessId] = this.item.defaultValue || null;
		}
	}
	// 切换步骤
	private changePoint(e, { key }) {
		if (e.target.className === 'steps-item-line' || this.isReadOnly || this.disabled) {
			return;
		}
		const options = this.item.options.filter((item) => !item.isDelete);
		const currentPoint = options.findIndex((op) => op.key === key);
		const oldIndex = options.findIndex((op) => op.key === this.oldValue);
		const restOption = options.slice(currentPoint + 1, oldIndex + 1);
		const noBackItem = restOption.find((item) => !item.allowBack);
		// 节点不能回退
		if (noBackItem) {
			Toast.fail({
				duration: 2000,
				message: `${noBackItem.value}不允许回退`,
			});
			return;
		}
		this.item.value = key;
		this.currentPoint = currentPoint;
		this.form[this.item.businessId] = key;
	}
}
